
import Formula from "@/components/Formula.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    yyyy: Number,
  },
  components: {
    Formula,
  },
})
export default class CenturyDoomsday extends Vue {
  yyyy!: number;

  floor(value: number): number {
    return Math.floor(value);
  }
}
